module.exports = __webpack_public_path__ + "img/restorejel_ecoset.5dfefa71.jpg";